// extracted by mini-css-extract-plugin
export var fadeInAnimation = "ResultModal-module--fadeInAnimation--67232";
export var form = "ResultModal-module--form--4882a";
export var hidden = "ResultModal-module--hidden--6db28";
export var layout = "ResultModal-module--layout--51b0d";
export var left = "ResultModal-module--left--92910";
export var right = "ResultModal-module--right--ab664";
export var subtitle = "ResultModal-module--subtitle--6e6e7";
export var wrapper = "ResultModal-module--wrapper--36aea";